import {
    fetchGet,
    fetchPost,
} from '~utilities/fetch';

export async function loanPaymentAbaGetRequest(loanPaymentAbaUuid: string): Promise<Response> {
    return fetchGet(`/loan-payment-abas/${loanPaymentAbaUuid}`);
}

export async function loanPaymentAbaHistoriesListRequest(loanPaymentAbaUuid: string): Promise<Response> {
    return fetchGet(`/loan-payment-abas/${loanPaymentAbaUuid}/history`);
}

export async function loanPaymentAbaWarehouseLoanTransactionsListRequest(loanPaymentAbaUuid: string): Promise<Response> {
    return fetchGet(`/loan-payment-abas/${loanPaymentAbaUuid}/warehouse-loan-transactions`);
}

export async function loanPaymentAbasAddRequest(warehouseLoanTransactionUuids: string[]): Promise<Response> {
    return fetchPost('/loan-payment-abas', { warehouseLoanTransactionUuids });
}

export async function loanPaymentAbasListRequest(): Promise<Response> {
    return fetchGet('/loan-payment-abas');
}

export async function loanPaymentAbasUnallocatedWarehouseLoanTransactionsListRequest(): Promise<Response> {
    return fetchGet('/loan-payment-abas/unallocated-warehouse-loan-transactions');
}
